const logsKeys = {
  module: ['logs'] as const,
  list: () => [...logsKeys.module, 'list'] as const,
  listWithFilters: (filters: any) => [...logsKeys.list(), filters] as const,
  details: (id: string) => [...logsKeys.module, 'details', id] as const,
};

export default logsKeys;
